import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = { class: "p-12" };
import SideBar from '@/layout/components/sidebar/SideBar.vue';
import ToolsBar from '@/layout/components/toolsbar/ToolsBar.vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LayoutView',
    setup: function (__props) {
        var keepAliveInclude = ref([
            'UniversalDevice', 'SpecialDevice', 'DeviceConfiguration', 'SceneConfiguration'
        ]);
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            var _component_el_scrollbar = _resolveComponent("el-scrollbar");
            var _component_el_main = _resolveComponent("el-main");
            var _component_el_container = _resolveComponent("el-container");
            return (_openBlock(), _createBlock(_component_el_container, {
                class: "layout-container flex-column",
                style: { "height": "100vh", "min-width": "1366px" }
            }, {
                default: _withCtx(function () { return [
                    _createVNode(ToolsBar, { class: "flex-shrink-0" }),
                    _createVNode(_component_el_container, { class: "overflow-auto" }, {
                        default: _withCtx(function () { return [
                            _createVNode(SideBar, { class: "flex-shrink-0" }),
                            _createVNode(_component_el_main, { class: "p-0" }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_el_scrollbar, { always: "" }, {
                                        default: _withCtx(function () { return [
                                            _createElementVNode("div", _hoisted_1, [
                                                _createVNode(_component_router_view, null, {
                                                    default: _withCtx(function (_a) {
                                                        var Component = _a.Component;
                                                        return [
                                                            (_openBlock(), _createBlock(_KeepAlive, { include: keepAliveInclude.value }, [
                                                                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                                                                    key: _ctx.$route.name
                                                                }))
                                                            ], 1032, ["include"]))
                                                        ];
                                                    }),
                                                    _: 1
                                                })
                                            ])
                                        ]; }),
                                        _: 1
                                    })
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    })
                ]; }),
                _: 1
            }));
        };
    }
});
